import { inject } from 'mobx-react';
import * as React from 'react';
import ESDataTableWithHeader from 'src/common/ESDataTableWithHeader';
import IDataTableManager from 'src/common/IDataTableManager';
import { DefaultBestPractice, IBestPractice } from 'src/Definitions';
import { IStores } from 'src/Stores';
import BestPracticeDialog from './BestPracticeDialog';

interface IBestPracticesProps {
    dataTableManager?: IDataTableManager<IBestPractice>;
    disableBestPractice?: (bestPractice: IBestPractice) => void;
    getColumnSettingsAndBestPractices?: () => void;
    isModalOpen?: boolean;
    openDialogWithBestPractice?: (bestPractice: IBestPractice) => void;
    recoverBestPractice?: (bestPractice: IBestPractice) => void;
}

@inject((stores: IStores) => ({
    dataTableManager: stores.bestPractices.dataTableStore,
    disableBestPractice: stores.bestPractices.disableBestPractice,
    getColumnSettingsAndBestPractices: stores.bestPractices.getColumnSettingsAndBestPractices,
    isModalOpen: stores.bestPractices.isModalOpen,
    openDialogWithBestPractice: stores.bestPractices.openDialogWithBestPractice,
    recoverBestPractice: stores.bestPractices.recoverBestPractice,
}))
class BestPractices extends React.Component<IBestPracticesProps> {
    public componentDidMount() {
        this.props.getColumnSettingsAndBestPractices!();
    }

    public render() {
        const bestPracticeDialog = this.props.isModalOpen && <BestPracticeDialog />;
        return (
            <>
                <ESDataTableWithHeader
                    dataTableManager={this.props.dataTableManager!}
                    enableEdit={true}
                    enableReorderColumns={true}
                    enableSearch={true}
                    enableToggleColumns={true}
                    openDialog={this.openDialog(DefaultBestPractice(true))}
                    title="Best Practices"
                />
                {bestPracticeDialog}
            </>
        );
    }

    public openDialog = (bestPractice: IBestPractice) => () => {
        this.props.openDialogWithBestPractice!(bestPractice);
    };
}

export default BestPractices;



// WEBPACK FOOTER //
// ./src/bestPractices/BestPractices.tsx